<script>
import Vue from 'vue';
import SkyVisible from 'sky-visible';

export default {
	name: 'sky-sticky',
	data() {
		return {
			sticky: false,
			contentDimensions: {
				height: 'auto',
				width: 'auto',
			},
		};
	},
	mounted() {
		this.recalculate();
		SkyVisible.bind(this.$el, 'outer', {
			foldOffset: true,
		}, this.scroll);

		SkyVisible.bind(this.$refs.stickyContent, 'outer', {
			foldOffset: true,
			recalculate: this.recalculate,
		});
	},
	methods: {
		scroll(values, dimensions, scroll) {
			this.toggle(scroll.y >= dimensions.top);
		},
		recalculate() {
			this.contentDimensions.height = 'auto';
			this.contentDimensions.width = 'auto';
			Vue.nextTick(() => {
				const dimensions = this.$refs.stickyContent.getBoundingClientRect();
				this.contentDimensions.height = `${dimensions.height}px`;
				this.contentDimensions.width = `${dimensions.width}px`;
			});
		},
		toggle(stickyState) {
			if (stickyState !== this.sticky) {
				this.sticky = stickyState;
			}
		},
	},
};
</script>

<style src="./sky-sticky.scss"></style>
<template src="./sky-sticky.html"></template>



// WEBPACK FOOTER //
// sky-sticky.vue?73b92f1d